import { render, staticRenderFns } from "./base-nav-tab-vertical.vue?vue&type=template&id=e7487316&scoped=true"
import script from "./base-nav-tab-vertical.vue?vue&type=script&lang=js"
export * from "./base-nav-tab-vertical.vue?vue&type=script&lang=js"
import style0 from "./base-nav-tab-vertical.vue?vue&type=style&index=0&id=e7487316&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7487316",
  null
  
)

export default component.exports